(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wt-pdp"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wt-pdp')) {
customElements.define('wt-pdp', class extends HTMLElement {
connectedCallback() {
if (this.initialized) return;
this.initialized = true;
const root = this.closest('product-info');
const bar = this.querySelector('.wt-sticky');
this.bar = bar;
document.body.appendChild(bar);
const button = bar.querySelector('button');
const price = bar.querySelector('[data-wt-price]');
let sizeChosen = new URLSearchParams(location.search).has('variant');
root.addEventListener('click', event => { if (event.target.matches('input[data-option-name="Size"]')) { sizeChosen = true; sync(); } });
root.addEventListener('change', event => { if (event.target.matches('input[data-option-name="Size"]')) { sizeChosen = true; sync(); } });
const sync = () => {
const native = root.querySelector('.product-form__submit');
if (!native) { bar.hidden = true; return; }
const box = native.getBoundingClientRect();
bar.hidden = box.top < innerHeight && box.bottom > 0;
const unavailable = native.disabled || native.getAttribute('aria-disabled') === 'true';
if (button.disabled !== unavailable) button.disabled = unavailable;
const needsSize = root.querySelector('input[data-option-name="Size"]') && !sizeChosen && !native.disabled;
const label = needsSize ? this.dataset.chooseSize : native.querySelector('span')?.textContent.trim();
if (label && button.textContent !== label) button.textContent = label;
const cost = root.querySelector('.price:not(.price--on-sale) .price-item--regular, .price--on-sale .price-item--sale')?.textContent.trim();
if (cost && price.textContent !== cost) price.textContent = cost;
};
button.addEventListener('click', () => {
const size = root.querySelector('input[data-option-name="Size"]');
if (size && !sizeChosen) { size.closest('fieldset').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'center'}); size.focus({preventScroll:true}); return; }
root.querySelector('.product-form__submit')?.click();
});
this.update = sync;
this.resizeObserver = new ResizeObserver(sync);
this.resizeObserver.observe(root);
window.addEventListener('scroll', sync, { passive: true });
window.addEventListener('resize', sync, { passive: true });
this.observer = new MutationObserver(sync);
this.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
sync();
}
disconnectedCallback() {
window.removeEventListener('scroll', this.update);
window.removeEventListener('resize', this.update);
this.observer?.disconnect();
this.resizeObserver?.disconnect();
this.bar?.remove();
this.initialized = false;
}
});
}

if (!customElements.get('wt-browse')) customElements.define('wt-browse',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const start=()=>{const grid=document.querySelector('#product-grid');if(!grid)return;const cards=Array.from(grid.querySelectorAll('[data-wt-handle]'));const picks=['watermelon-long-sleeve','template15','pixelated-memories-tee','template13','computa-belt','template14'];const category=card=>{const name=card.dataset.wtTitle.toLowerCase();if(name.includes('hoodie'))return 'hoodies';if(name.includes('long sleeve'))return 'longsleeves';if(name.includes('tee')||name.includes('shirt'))return 'tees';if(name.includes('jeans')||name.includes('pants'))return 'bottoms';return 'accessories';};let selected='all';const update=()=>{let visible=0;cards.forEach(card=>{card.hidden=selected!=='all'&&category(card)!==selected;if(!card.hidden)visible++;});this.querySelector('[data-wt-count]').textContent=visible+' / '+cards.length;};this.querySelectorAll('[data-wt-category]').forEach(button=>{const value=button.dataset.wtCategory;if(value!=='all'&&!cards.some(card=>category(card)===value)){button.hidden=true;return;}button.addEventListener('click',()=>{selected=value;this.querySelectorAll('[data-wt-category]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));update();});});const sort=this.querySelector('[data-wt-sort]');const reorder=()=>{const ordered=[...cards].sort((a,b)=>{if(sort.value==='low')return Number(a.dataset.wtPrice)-Number(b.dataset.wtPrice);if(sort.value==='high')return Number(b.dataset.wtPrice)-Number(a.dataset.wtPrice);const rank=c=>{const n=picks.indexOf(c.dataset.wtHandle);return n<0?999:n;};return rank(a)-rank(b);});ordered.forEach(card=>grid.appendChild(card));};sort.addEventListener('change',reorder);reorder();update();};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wt-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wt-size-guide')) {
    customElements.define('wt-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const dialog = this.querySelector('dialog');
        const opener = this.querySelector('.wt-guide-open');
        opener.hidden = false;
        opener.addEventListener('click', () => {
          const picker = this.closest('variant-selects');
          const sizeGroup = Array.from(picker?.querySelectorAll('fieldset') || []).find(group => group.querySelector('legend')?.textContent.trim().toLowerCase() === 'size');
          const selected = sizeGroup?.querySelector('input:checked')?.value;
          this.querySelectorAll('tr[data-size]').forEach(row => row.toggleAttribute('data-selected', row.dataset.size === selected));
          dialog.showModal();
        });
        this.querySelector('.wt-guide-close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          const box = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
        });
        dialog.addEventListener('close', () => opener.focus({preventScroll:true}));
        this.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
          this.querySelectorAll('[data-unit]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
          this.querySelectorAll('td[data-cm]').forEach(cell => { cell.textContent = cell.dataset[button.dataset.unit]; });
          this.querySelector('.wt-guide-unit-label').textContent = button.textContent;
        }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
